module.exports = __webpack_public_path__ + "img/icon_loan_coupon_discount.67ce2361.png";